import { parseDateTime } from 'utils/dates/date.utils';
import { getBoundedValue } from 'utils/math/math.utils';

export const getDay15ForecastWidgetLayout = ({ containerSizePx, dimensions }) => {
  const containerWidth = Number.isFinite(containerSizePx?.width) ? containerSizePx.width : 320;
  const isSingleColumnWidget = dimensions?.[0] === 1;

  const arrowButtonWidth = getBoundedValue(
    Math.round(containerWidth * (isSingleColumnWidget ? 0.11 : 0.065)),
    30,
    50,
  );

  const rowTileIconSize = getBoundedValue(Math.round(containerWidth * 0.09), 26, 38);
  const tileIconSize = getBoundedValue(Math.round(containerWidth * 0.11), 30, 46);
  const tileFontSize = getBoundedValue(Math.round(containerWidth * 0.04), 11, 14);
  const tileTextStyle = {
    fontSize: tileFontSize,
    lineHeight: 1.05,
  };

  return {
    arrowButtonWidth,
    arrowIconSize: getBoundedValue(Math.round(arrowButtonWidth * 0.42), 14, 20),
    compact1x1VisibleCount: containerWidth <= 340 ? 2 : 3,
    compact1x2ColumnCount: containerWidth < 360 ? 2 : containerWidth < 480 ? 3 : 4,
    rowTileIconSize,
    tileIconSize,
    tileTextStyle,
  };
};

export const formatTileLabel = (item) => {
  const date = parseDateTime(item?.iso8601);

  if (!date) return '';

  return new Intl.DateTimeFormat(undefined, {
    month: 'numeric',
    day: 'numeric',
  }).format(date);
};

const getTemperatureAriaLabel = (temperature) => {
  const numericTemperature = parseFloat(temperature);

  if (!Number.isFinite(numericTemperature)) return 'temperature unavailable';

  return `${numericTemperature.toFixed(0)} degrees Fahrenheit`;
};

export const getDay15ForecastTileAriaLabel = (item) => {
  const dateLabel = formatTileLabel(item) || 'this date';
  const highTemperatureLabel = getTemperatureAriaLabel(item?.high_temp);
  const lowTemperatureLabel = getTemperatureAriaLabel(item?.low_temp);

  return `Select 15-day forecast for ${dateLabel}, high ${highTemperatureLabel}, low ${lowTemperatureLabel}`;
};
